import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmploymentType, EmploymentTypeCreate, EmploymentTypeFilter } from '../data/employmentType';

export function createEmploymentTypeService(client: AxiosInstance) {
  return createCrudService<EmploymentType, EmploymentTypeCreate, EmploymentTypeFilter>(
    client,
    '/hrm/EmploymentType',
    'id',
  );
}

export type EmploymentTypeService = CrudService<EmploymentType, EmploymentTypeCreate, EmploymentTypeFilter>;
